import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { t } from '@lingui/macro'
import { useLingui } from '@lingui/react'
import { Grid } from '@mui/material'

import InfoSection from '@/components/ui/sections/InfoSection'
import TextInputController from '@/components/ui/inputs/TextInputController'
import { useIsUS } from '@/hooks/useIsUS'
import { useIsMobile } from '@/hooks/useSizeBreakpoints'

import { PatientProfileFormData } from '../model/usePatientProfileForm'

export function MedicalInfoSection({ editable }: { editable: boolean }) {
  useLingui()
  const i18next = useTranslation()
  const rhForm = useFormContext<PatientProfileFormData>()
  const isMobile = useIsMobile()
  const isUS = useIsUS()
  const xs = isMobile ? 12 : 6
  return (
    <InfoSection label={t`Medical information`}>
      <Grid container spacing={3} mt={0}>
        <Grid item xs={6}>
          <TextInputController control={rhForm.control} id="weight" fullWidth label={t`Weight (kg)`} name="weight" readOnly={!editable} />
        </Grid>
        <Grid item xs={6}>
          <TextInputController control={rhForm.control} id="height" fullWidth label={t`Height (cm)`} name="height" readOnly={!editable} />
        </Grid>
        <Grid item xs={xs}>
          <TextInputController control={rhForm.control} id="allergy" fullWidth label={t`Allergy`} name="allergy" readOnly={!editable} />
        </Grid>
        <Grid item xs={xs}>
          <TextInputController control={rhForm.control} id="vaccins" fullWidth label={t`Vaccin`} name="vaccins" readOnly={!editable} />
        </Grid>
        <Grid item xs={12}>
          <TextInputController control={rhForm.control} id="notes" fullWidth label={t`Note`} multiline minRows={3} name="notes" readOnly={!editable} />
        </Grid>
        <Grid item xs={12}>
          <TextInputController control={rhForm.control} multiline fullWidth label={t`Treatments`} minRows={3} name="treatment" readOnly={!editable} />
        </Grid>
        <Grid item xs={12}>
          <TextInputController control={rhForm.control} multiline fullWidth label={t`Background`} minRows={3} name="background" readOnly={!editable} />
        </Grid>
        {isUS && (
          <Grid item xs={12}>
            <TextInputController multiline fullWidth label={i18next.t('field.primaryPharmacy.label')} name="primaryPharmacy" readOnly={!editable} />
          </Grid>
        )}
      </Grid>
    </InfoSection>
  )
}
